import { organizationRoutes } from './organizations';
import { contactRoutes } from './contacts';
import { subscriptionRoutes } from './subscriptions';
import { orderRoutes } from './orders';
import { billingOrderRoutes } from './billing-orders';
import { requestRoutes } from './requests';

export const accountsRoutes = [
  {
    path: 'accounts',
    children: [
      ...organizationRoutes,
      ...contactRoutes,
      ...subscriptionRoutes,
      ...orderRoutes,
      ...billingOrderRoutes,
      ...requestRoutes,
    ],
  },
];
